const CODE_PREFIX = /^(reason|buyer|channel|payment|line_message|state|cancel)\./
const MINUTES_PER_DAY = 24 * 60

const wordsFor = (journey, key, lang) => {
  const label = journey?.labels?.[key]
  const code = key.replace(CODE_PREFIX, '')
  if (!label || typeof label !== 'object') return code
  return label[lang] || label.en || code
}

const joined = (parts) => parts.filter(Boolean).join(' · ')

const reasonKey = (code) => `reason.${code}`
const buyerKey = (buyer) => `buyer.${buyer}`
const channelKey = (channel) => `channel.${channel}`
const paymentKey = (method) => `payment.${method}`
const lineMessageKey = (messageType) => `line_message.${messageType}`
const stateKey = (state) => `state.${state?.kind}`
const cancelKey = (reason) => `cancel.${reason}`

const relativeDay = (t, daysBefore) => {
  if (daysBefore === 0) return t('orderJourney.orderDay')
  if (daysBefore < 0) return t('orderJourney.daysAfter', { count: -daysBefore })
  return t('orderJourney.daysBefore', { count: daysBefore })
}

const durationOf = (t, fromIso, toIso) => {
  const minutes = Math.max(Math.round((Date.parse(toIso) - Date.parse(fromIso)) / 60000), 0)
  const days = Math.floor(minutes / MINUTES_PER_DAY)
  const hours = Math.floor((minutes % MINUTES_PER_DAY) / 60)
  if (days > 0) return t('orderJourney.durationDays', { count: days, hours })
  if (hours > 0) return t('orderJourney.durationHours', { hours, minutes: minutes % 60 })
  return t('orderJourney.durationMinutes', { count: minutes })
}

const creditOf = (attribution, startedAt) => {
  if (!attribution) return null
  const level = attribution.holdout
    ? 'holdout'
    : attribution.paid_with_code
      ? 'code'
      : attribution.clicked
        ? 'link'
        : 'message'
  return {
    level,
    flowName: attribution.flow_name,
    exposedAt: attribution.exposed_at,
    colleague: attribution.colleague === true,
    afterOrder: !attribution.holdout && Date.parse(attribution.exposed_at) > Date.parse(startedAt)
  }
}

export {
  wordsFor,
  joined,
  reasonKey,
  buyerKey,
  channelKey,
  paymentKey,
  lineMessageKey,
  stateKey,
  cancelKey,
  relativeDay,
  durationOf,
  creditOf
}
